"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentOutput = instanceOfDocumentOutput;
exports.DocumentOutputFromJSON = DocumentOutputFromJSON;
exports.DocumentOutputFromJSONTyped = DocumentOutputFromJSONTyped;
exports.DocumentOutputToJSON = DocumentOutputToJSON;
var Metadata_1 = require("./Metadata");
var Document_1 = require("./Document");
/**
 * Check if a given object implements the DocumentOutput interface.
 */
function instanceOfDocumentOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function DocumentOutputFromJSON(json) {
    return DocumentOutputFromJSONTyped(json, false);
}
function DocumentOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Document_1.DocumentFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function DocumentOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Document_1.DocumentToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
